export const colorOptions = [
  { name: "purple", color: "#7F2FEF" },
  { name: "plum", color: "#7E33A2" },
  { name: "blue", color: "#1556A2" },
  { name: "colbalt", color: "#2F59EF" },
  { name: "turquoise", color: "#35D2E9" },
  { name: "teal", color: "#569FA9" },
  { name: "green", color: "#0FA852" },
  { name: "fern", color: "#5B945A" },
  { name: "yellow", color: "#FFED1F" },
  { name: "corn", color: "#EBBA3A" },
  { name: "orange", color: "#FFAF1F" },
  { name: "brick", color: "#BA4E36" },
  { name: "rust", color: "#CA661E" },
  /*{ name: "red", color: "#B80D00" },*/
  { name: "magenta", color: "#D233EC" },
  { name: "pink", color: "#F91A9F" },
]

export const tintsObj = {
  "white": "hsl(0,0%,100%)",
  "black": "hsl(0,0%,0%)",
  "grey": {
    "$token-color-grey-10": "hsl(0,0%,96%)",
    "$token-color-grey-20": "hsl(0,0%,85%)",
    "$token-color-grey-30": "hsl(0,0%,74%)",
    "$token-color-grey-40": "hsl(0,0%,63%)",
    "$token-color-grey-50": "hsl(0,0%,52%)",
    "$token-color-grey-60": "hsl(0,0%,41%)",
    "$token-color-grey-70": "hsl(0,0%,30%)",
    "$token-color-grey-80": "hsl(0,0%,19%)",
    "$token-color-grey-90": "hsl(0,0%,8%)"
  },
  "red": {
    "$token-color-red-10": "hsl(4,100%,96%)",
    "$token-color-red-20": "hsl(4,100%,86%)",
    /*"$token-color-red-30": "hsl(4,100%,76%)",*/
    /*"$token-color-red-40": "hsl(4,100%,66%)",*/
    /*"$token-color-red-50": "hsl(4,100%,56%)",*/
    "$token-color-red-60": "hsl(4,100%,46%)",
    "$token-color-red-70": "hsl(4,100%,36%)",
    "$token-color-red-80": "hsl(4,100%,26%)",
    "$token-color-red-90": "hsl(4,100%,16%)"
  }
}

export const globalColor = {
  "white": "hsl(0,0%,100%)",
  "black": "hsl(0,0%,0%)",
  "grey": {
    "$token-color-grey-10": "hsl(0,0%,96%)",
    "$token-color-grey-20": "hsl(0,0%,85%)",
    "$token-color-grey-30": "hsl(0,0%,74%)",
    "$token-color-grey-40": "hsl(0,0%,63%)",
    "$token-color-grey-50": "hsl(0,0%,52%)",
    "$token-color-grey-60": "hsl(0,0%,41%)",
    "$token-color-grey-70": "hsl(0,0%,30%)",
    "$token-color-grey-80": "hsl(0,0%,19%)",
    "$token-color-grey-90": "hsl(0,0%,8%)"
  },
  "purple": {
    "$token-color-purple-10": "hsl(265,86%,96%)", "$token-color-purple-20": "hsl(265,86%,86%)", "$token-color-purple-30": "hsl(265,86%,76%)", "$token-color-purple-40": "hsl(265,86%,66%)", "$token-color-purple-50": "hsl(265,86%,56%)", "$token-color-purple-60": "hsl(265,86%,46%)", "$token-color-purple-70": "hsl(265,86%,36%)", "$token-color-purple-80": "hsl(265,86%,26%)", "$token-color-purple-90": "hsl(265,86%,16%)"
  },
  "plum": {
    "$token-color-plum-10": "hsl(281,52%,96%)", "$token-color-plum-20": "hsl(281,52%,86%)", "$token-color-plum-30": "hsl(281,52%,76%)", "$token-color-plum-40": "hsl(281,52%,66%)", "$token-color-plum-50": "hsl(281,52%,56%)", "$token-color-plum-60": "hsl(281,52%,46%)", "$token-color-plum-70": "hsl(281,52%,36%)", "$token-color-plum-80": "hsl(281,52%,26%)", "$token-color-plum-90": "hsl(281,52%,16%)"
  },
  "blue": {
    "$token-color-blue-10": "hsl(212,77%,96%)", "$token-color-blue-20": "hsl(212,77%,86%)", "$token-color-blue-30": "hsl(212,77%,76%)", "$token-color-blue-40": "hsl(212,77%,66%)", "$token-color-blue-50": "hsl(212,77%,56%)", "$token-color-blue-60": "hsl(212,77%,46%)", "$token-color-blue-70": "hsl(212,77%,36%)", "$token-color-blue-80": "hsl(212,77%,26%)", "$token-color-blue-90": "hsl(212,77%,16%)"
  },
  "cobalt": {
    "$token-color-cobalt-10": "hsl(227,86%,96%)", "$token-color-cobalt-20": "hsl(227,86%,86%)", "$token-color-cobalt-30": "hsl(227,86%,76%)", "$token-color-cobalt-40": "hsl(227,86%,66%)", "$token-color-cobalt-50": "hsl(227,86%,56%)", "$token-color-cobalt-60": "hsl(227,86%,46%)", "$token-color-cobalt-70": "hsl(227,86%,36%)", "$token-color-cobalt-80": "hsl(227,86%,26%)", "$token-color-cobalt-90": "hsl(227,86%,16%)"
  },
  "turquoise": {
    "$token-color-turquoise-10": "hsl(187,80%,96%)", "$token-color-turquoise-20": "hsl(187,80%,86%)", "$token-color-turquoise-30": "hsl(187,80%,76%)", "$token-color-turquoise-40": "hsl(187,80%,66%)", "$token-color-turquoise-50": "hsl(187,80%,56%)", "$token-color-turquoise-60": "hsl(187,80%,46%)", "$token-color-turquoise-70": "hsl(187,80%,36%)", "$token-color-turquoise-80": "hsl(187,80%,26%)", "$token-color-turquoise-90": "hsl(187,80%,16%)"
  },
  "teal": {
    "$token-color-teal-10": "hsl(187,33%,96%)", "$token-color-teal-20": "hsl(187,33%,86%)", "$token-color-teal-30": "hsl(187,33%,76%)", "$token-color-teal-40": "hsl(187,33%,66%)", "$token-color-teal-50": "hsl(187,33%,56%)", "$token-color-teal-60": "hsl(187,33%,46%)", "$token-color-teal-70": "hsl(187,33%,36%)", "$token-color-teal-80": "hsl(187,33%,26%)", "$token-color-teal-90": "hsl(187,33%,16%)"
  },
  "green": {
    "$token-color-green-10": "hsl(146,83%,96%)", "$token-color-green-20": "hsl(146,83%,86%)", "$token-color-green-30": "hsl(146,83%,76%)", "$token-color-green-40": "hsl(146,83%,66%)", "$token-color-green-50": "hsl(146,83%,56%)", "$token-color-green-60": "hsl(146,83%,46%)", "$token-color-green-70": "hsl(146,83%,36%)", "$token-color-green-80": "hsl(146,83%,26%)", "$token-color-green-90": "hsl(146,83%,16%)"
  },
  "fern": {
    "$token-color-fern-10": "hsl(119,24%,96%)", "$token-color-fern-20": "hsl(119,24%,86%)", "$token-color-fern-30": "hsl(119,24%,76%)", "$token-color-fern-40": "hsl(119,24%,66%)", "$token-color-fern-50": "hsl(119,24%,56%)", "$token-color-fern-60": "hsl(119,24%,46%)", "$token-color-fern-70": "hsl(119,24%,36%)", "$token-color-fern-80": "hsl(119,24%,26%)", "$token-color-fern-90": "hsl(119,24%,16%)"
  },
  "yellow": {
    "$token-color-yellow-10": "hsl(55,100%,96%)", "$token-color-yellow-20": "hsl(55,100%,86%)", "$token-color-yellow-30": "hsl(55,100%,76%)", "$token-color-yellow-40": "hsl(55,100%,66%)", "$token-color-yellow-50": "hsl(55,100%,56%)", "$token-color-yellow-60": "hsl(55,100%,46%)", "$token-color-yellow-70": "hsl(55,100%,36%)", "$token-color-yellow-80": "hsl(55,100%,26%)", "$token-color-yellow-90": "hsl(55,100%,16%)"
  },
  "corn": {
    "$token-color-corn-10": "hsl(43,82%,96%)", "$token-color-corn-20": "hsl(43,82%,86%)", "$token-color-corn-30": "hsl(43,82%,76%)", "$token-color-corn-40": "hsl(43,82%,66%)", "$token-color-corn-50": "hsl(43,82%,56%)", "$token-color-corn-60": "hsl(43,82%,46%)", "$token-color-corn-70": "hsl(43,82%,36%)", "$token-color-corn-80": "hsl(43,82%,26%)", "$token-color-corn-90": "hsl(43,82%,16%)"
  },
  "orange": {
    "$token-color-orange-10": "hsl(39,100%,96%)", "$token-color-orange-20": "hsl(39,100%,86%)", "$token-color-orange-30": "hsl(39,100%,76%)", "$token-color-orange-40": "hsl(39,100%,66%)", "$token-color-orange-50": "hsl(39,100%,56%)", "$token-color-orange-60": "hsl(39,100%,46%)", "$token-color-orange-70": "hsl(39,100%,36%)", "$token-color-orange-80": "hsl(39,100%,26%)", "$token-color-orange-90": "hsl(39,100%,16%)"
  },
  "brick": {
    "$token-color-brick-10": "hsl(11,55%,96%)", "$token-color-brick-20": "hsl(11,55%,86%)", "$token-color-brick-30": "hsl(11,55%,76%)", "$token-color-brick-40": "hsl(11,55%,66%)", "$token-color-brick-50": "hsl(11,55%,56%)", "$token-color-brick-60": "hsl(11,55%,46%)", "$token-color-brick-70": "hsl(11,55%,36%)", "$token-color-brick-80": "hsl(11,55%,26%)", "$token-color-brick-90": "hsl(11,55%,16%)"
  },
  "rust": {
    "$token-color-rust-10": "hsl(25,74%,96%)", "$token-color-rust-20": "hsl(25,74%,86%)", "$token-color-rust-30": "hsl(25,74%,76%)", "$token-color-rust-40": "hsl(25,74%,66%)", "$token-color-rust-50": "hsl(25,74%,56%)", "$token-color-rust-60": "hsl(25,74%,46%)", "$token-color-rust-70": "hsl(25,74%,36%)", "$token-color-rust-80": "hsl(25,74%,26%)", "$token-color-rust-90": "hsl(25,74%,16%)"
  },
  "red": {
    "$token-color-red-10": "hsl(4,100%,96%)",
    "$token-color-red-20": "hsl(4,100%,86%)",
    /*"$token-color-red-30": "hsl(4,100%,76%)",*/
    /*"$token-color-red-40": "hsl(4,100%,66%)",*/
    /*"$token-color-red-50": "hsl(4,100%,56%)",*/
    "$token-color-red-60": "hsl(4,100%,46%)",
    "$token-color-red-70": "hsl(4,100%,36%)",
    "$token-color-red-80": "hsl(4,100%,26%)",
    "$token-color-red-90": "hsl(4,100%,16%)"
  },
  "magenta": {
    "$token-color-magenta-10": "hsl(292,83%,96%)", "$token-color-magenta-20": "hsl(292,83%,86%)", "$token-color-magenta-30": "hsl(292,83%,76%)", "$token-color-magenta-40": "hsl(292,83%,66%)", "$token-color-magenta-50": "hsl(292,83%,56%)", "$token-color-magenta-60": "hsl(292,83%,46%)", "$token-color-magenta-70": "hsl(292,83%,36%)", "$token-color-magenta-80": "hsl(292,83%,26%)", "$token-color-magenta-90": "hsl(292,83%,16%)"
  },
  "pink": {
    "$token-color-pink-10": "hsl(324,95%,96%)", "$token-color-pink-20": "hsl(324,95%,86%)", "$token-color-pink-30": "hsl(324,95%,76%)", "$token-color-pink-40": "hsl(324,95%,66%)", "$token-color-pink-50": "hsl(324,95%,56%)", "$token-color-pink-60": "hsl(324,95%,46%)", "$token-color-pink-70": "hsl(324,95%,36%)", "$token-color-pink-80": "hsl(324,95%,26%)", "$token-color-pink-90": "hsl(324,95%,16%)"
  }
}

export const semanticColor = {
  '$token-color-background-primary': {
    token: '$token-color-white'
  },
  '$token-color-background-secondary': {
    token: '$token-color-grey-10'
  },
  '$token-color-background-action-primary': {
    token: '$token-color-blue-70'
  },
  '$token-color-background-action-primary-hover': {
    token: '$token-color-blue-60'
  },
  '$token-color-background-action-secondary': {
    token: '$token-color-white'
  },
  '$token-color-background-action-secondary-hover': {
    token: '$token-color-blue-10'
  },
  '$token-color-background-action-tertiary': {
    token: '$token-color-white'
  },
  '$token-color-background-action-tertiary-hover': {
    token: '$token-color-blue-10'
  },
  '$token-color-background-action-disabled': {
    token: '$token-color-grey-20'
  },
  '$token-color-background-action-danger': {
    token: '$token-color-red-70'
  },
  '$token-color-background-action-danger-hover': {
    token: '$token-color-red-60'
  },
  '$token-color-background-danger': {
    token: '$token-color-red-10'
  },
  '$token-color-background-info': {
    token: '$token-color-blue-10'
  },
  '$token-color-font-primary': {
    token: '$token-color-grey-90'
  },
  '$token-color-font-secondary': {
    token: '$token-color-grey-60'
  },
  '$token-color-font-tertiary': {
    token: '$token-color-blue-80'
  },
  '$token-color-font-inverse': {
    token: '$token-color-white'
  },
  '$token-color-font-disabled': {
    token: '$token-color-grey-60'
  },
  '$token-color-font-link': {
    token: '$token-color-blue-80'
  },
  '$token-color-font-link-hover': {
    token: '$token-color-blue-70'
  },
  '$token-color-font-danger': {
    token: '$token-color-red-70'
  },
  '$token-color-font-info': {
    token: '$token-color-blue-80'
  },
  '$token-color-border-primary': {
    token: '$token-color-grey-10'
  },
  '$token-color-border-secondary': {
    token: '$token-color-grey-20'
  },
  '$token-color-border-tertiary': {
    token: '$token-color-blue-70'
  },
  '$token-color-border-selected': {
    token: '$token-color-blue-50'
  },
  '$token-color-border-inverse': {
    token: '$token-color-white'
  },
  '$token-color-border-action-primary': {
    token: '$token-color-blue-70'
  },
  '$token-color-border-action-primary-hover': {
    token: '$token-color-blue-60'
  },
  '$token-color-border-action-secondary': {
    token: '$token-color-blue-70'
  },
  '$token-color-border-action-secondary-hover': {
    token: '$token-color-blue-70'
  },
  '$token-color-border-action-tertiary': {
    token: '$token-color-white'
  },
  '$token-color-border-action-tertiary-hover': {
    token: '$token-color-blue-10'
  },
}

